import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	containerWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		justifyContent: 'center',
		rowGap: '50px',
		height: '60vh'
	},
	heading: {
		color: theme.palette.primary.main
	},
	formLabel: {
		color: theme.palette.primary.main
	},
	rowWrapper: {
		display: 'flex'
	},
	numberOfTimesFormFieldWrapper: {
		marginLeft: 'auto'
	},

	container: {
		paddingTop: '2rem',
		paddingLeft: '2rem',
		paddingRight: '2rem',

		height: '100vh'
	},
	wrapper: {
		height: '100%',
		width: '100%'
	},
	buttonWrapper: {
		display: 'flex',
		columnGap: '1rem'
	},
	configWrapper: {
		display: 'flex'
	}
}));
